module.exports = __webpack_public_path__ + "static/coworking2-4ba805e39c7bb968fd5d5c3440d8f7d3.jpg";